<div class="content-page">
  <div class="contact-container">
    <div class="contact-grid">
      <div class="contact-info">
        <span class="section-tag">Contact</span>
        <h1 class="page-title">Get in touch</h1>
        <p class="page-subtitle">Have a question or need help? We're here for you.</p>

        <div class="contact-channels">
          <div class="channel">
            <div class="channel-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            </div>
            <div>
              <div class="channel-label">Email</div>
              <a href="mailto:support@quickindexingtool.com" class="channel-value">support&#64;quickindexingtool.com</a>
            </div>
          </div>

          <div class="channel">
            <div class="channel-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            </div>
            <div>
              <div class="channel-label">Response time</div>
              <span class="channel-value">Within a few hours</span>
            </div>
          </div>

          <div class="channel">
            <div class="channel-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
            </div>
            <div>
              <div class="channel-label">Status</div>
              <a routerLink="/" class="channel-value">All systems operational</a>
            </div>
          </div>
        </div>
      </div>

      <div class="contact-form-card">
        <h2>Send us a message</h2>
        <form #contactForm="ngForm" (ngSubmit)="contactForm.valid && sendMessage()" class="contact-form">
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Name</label>
              <input type="text" class="form-control" [(ngModel)]="contactData.name" name="name" required minlength="2" #nameInput="ngModel" />
              <div class="form-error" *ngIf="nameInput.invalid && (nameInput.dirty || nameInput.touched)">
                <span *ngIf="nameInput.errors?.['required']">Name is required</span>
                <span *ngIf="nameInput.errors?.['minlength']">Name must be at least 2 characters</span>
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">Email</label>
              <input type="email" class="form-control" [(ngModel)]="contactData.email" name="email" required #emailInput="ngModel" />
              <div class="form-error" *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)">
                <span *ngIf="emailInput.errors?.['required']">Email is required</span>
                <span *ngIf="emailInput.errors?.['email']">Please enter a valid email</span>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Subject</label>
            <select class="form-control" [(ngModel)]="contactData.subject" name="subject">
              <option value="general">General question</option>
              <option value="billing">Billing & payments</option>
              <option value="technical">Technical support</option>
              <option value="api">API support</option>
              <option value="partnership">Partnership inquiry</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">Message</label>
            <textarea class="form-control" rows="5" [(ngModel)]="contactData.message" name="message" required minlength="10" #messageInput="ngModel"></textarea>
            <div class="form-error" *ngIf="messageInput.invalid && (messageInput.dirty || messageInput.touched)">
              <span *ngIf="messageInput.errors?.['required']">Message is required</span>
              <span *ngIf="messageInput.errors?.['minlength']">Message must be at least 10 characters</span>
            </div>
          </div>

          <div *ngIf="successMessage" class="form-success">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
            <span>{{ successMessage }}</span>
          </div>

          <div *ngIf="errorMessage" class="form-error">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            <span>{{ errorMessage }}</span>
          </div>

          <button type="submit" class="btn btn-primary contact-submit" [disabled]="isSending || contactForm.invalid">
            <span class="spinner spinner-sm" *ngIf="isSending"></span>
            <span>{{ isSending ? 'Sending...' : 'Send message' }}</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
